/* ZED Compare Kits (spec 74_). New file, not part of Athens. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var NAMES = { mm: 'Middle Man', bs: 'Battle Station', pp: 'Power Plate' };
  var KEY = 'zck-brand';

  function store(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  // Height of the site header once it is stuck to the top (Athens keeps it sticky).
  function headerBottom() {
    var h = document.querySelector('.section-header');
    if (!h) return 0;
    var cs = getComputedStyle(h);
    var r = h.getBoundingClientRect();
    if (cs.position === 'sticky' || cs.position === 'fixed') return Math.round((parseFloat(cs.top) || 0) + r.height);
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (root.__zck) return;
    root.__zck = true;
    var full = root.getAttribute('data-mode') !== 'compact';
    var job = null;
    var live = root.querySelector('[data-zck-live]');
    var empty = root.querySelector('[data-zck-empty]');
    var verdicts = root.querySelectorAll('[data-zck-verdict]');
    var chips = root.querySelectorAll('[data-zck-job]');
    var segs = root.querySelectorAll('[data-zck-brand]');

    function brand() { return root.getAttribute('data-brand') || 'mil'; }

    function activeVerdict() {
      if (!job) return null;
      var b = brand();
      for (var i = 0; i < verdicts.length; i++) {
        var v = verdicts[i];
        if (v.getAttribute('data-zck-verdict') !== job) continue;
        var zb = v.getAttribute('data-zb');
        if (zb && (' ' + zb + ' ').indexOf(' ' + b + ' ') === -1) continue;
        return v;
      }
      return null;
    }

    function render(announce) {
      var b = brand();
      for (var i = 0; i < segs.length; i++) {
        segs[i].setAttribute('aria-pressed', segs[i].getAttribute('data-zck-brand') === b ? 'true' : 'false');
      }
      for (var j = 0; j < chips.length; j++) {
        chips[j].setAttribute('aria-pressed', chips[j].getAttribute('data-zck-job') === job ? 'true' : 'false');
      }
      var act = activeVerdict();
      for (var k = 0; k < verdicts.length; k++) verdicts[k].hidden = verdicts[k] !== act;
      if (empty) empty.hidden = !!act;
      var pick = act ? (act.getAttribute('data-vkit') || '') : (root.getAttribute('data-current') || '');
      root.setAttribute('data-pick', pick);
      if (announce && live) {
        live.textContent = act ? (pick ? NAMES[pick] + ' suggested for that job.' : 'Heads up: mismatched packs need the Milwaukee Middle Man.') : '';
      }
      return act;
    }

    function scrollToVerdict(v) {
      if (!v) return;
      var r = v.getBoundingClientRect();
      var top = headerBottom();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      // Leave it alone when the card's top is already comfortably on screen (desktop: it sits beside the jobs).
      if (r.top >= top + 8 && (r.bottom <= vh - 8 || r.top <= vh * 0.55)) return;
      var y = window.pageYOffset + r.top - top - 12;
      // Keep as much of the card on screen as possible; never scroll the chips far away on a tall card.
      try { window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
    }

    for (var s = 0; s < segs.length; s++) {
      segs[s].addEventListener('click', function () {
        var b = this.getAttribute('data-zck-brand');
        root.setAttribute('data-brand', b);
        store(b);
        render(false);
      });
    }
    for (var c = 0; c < chips.length; c++) {
      chips[c].addEventListener('click', function () {
        var id = this.getAttribute('data-zck-job');
        job = job === id ? null : id;
        var v = render(true);
        if (v) scrollToVerdict(v);
      });
    }

    // Compact mode (kit pages): the current kit's Choose goes to this page's own buy box.
    root.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-zck-buy]') : null;
      if (!a) return;
      var form = document.querySelector('.product-block-product-form') || document.querySelector('product-form, form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var y = window.pageYOffset + form.getBoundingClientRect().top - headerBottom() - 16;
      try { window.scrollTo({ top: Math.max(0, y), behavior: reduced() ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, y); }
    });

    // Pinned strip: only while the table is on screen and its own header row has scrolled away.
    var pin = root.querySelector('[data-zck-pin]');
    var thead = root.querySelector('[data-zck-thead]');
    var tend = root.querySelector('[data-zck-tend]');
    if (pin && thead && tend) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var top = headerBottom();
        root.style.setProperty('--zck-top', top + 'px');
        var h = thead.getBoundingClientRect();
        var end = tend.getBoundingClientRect();
        var on = h.bottom < top && end.top > top + pin.offsetHeight + 40;
        if (on !== pin.classList.contains('is-on')) pin.classList.toggle('is-on', on);
      };
      var req = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      update();
    }

    render(false);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-zck]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
